import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import {
    PrescriberUpsearchModel,
    RemovePrescriberRequestModel,
    PrescriberModel,
} from '@trialcard/apigateway.models';
import { ApigatewayApi } from '@trialcard/apigateway.client';
import * as enums from '@trialcard/enums';
import { OnClear } from '~/services/clearModule';
import { Settings } from '~/services/settings';

/* eslint-disable dot-notation */
@InjectModule({ stateFactory: true }, module)
@OnClear<PrescriberModule>(async value => value.clear())
export default class PrescriberModule extends InjectVuexModule {
    @Resolve
    apiGateway!: ApigatewayApi;
    @Resolve
    public settings!: Settings;

    prescriberModels: PrescriberModel[] = [];

    @Mutation
    clear() {}

    @Mutation
    setPrescriberModel(prescribers: PrescriberModel[]) {
        this.prescriberModels = prescribers;
    }

    @Action({ rawError: true })
    async getPrescribersAPI(body: any = {}) {
        try {
            const prescribers = await this.apiGateway.edgeAccount
                .accountGetPrescribers(body)
                .then(data => {
                    (data.data.data || []).map(item => {
                        item['state'] = ((item.addresses || [])[0] || {}).state || '';
                        item['fullName'] = `${(item || {}).firstName} ${(item || {}).lastName}`;
                        return item;
                    });
                    return data;
                })
                .catch(error => {
                    throw error;
                });
            this.setPrescriberModel(prescribers.data.data || []);
            return this.prescriberModels;
        } catch {
            return;
        }
    }
    @Action({ rawError: true })
    async addPrescriberAPI(prescriber: PrescriberUpsearchModel) {
        try {
            const saveCall = await this.apiGateway.edgeAccount.accountSavePrescriber(prescriber, this.settings.programId);

            return (saveCall.data || {}).success;
        } catch {
            return;
        }
    }
    @Action({ rawError: true })
    async deletePrescriberAPI(prescriberId: number) {
        try {
            const prescriber = { prescriberId } as RemovePrescriberRequestModel;
            const postDeleteCall = await this.apiGateway.edgeAccount.accountRemovePrescriber(prescriber, this.settings.programId);

            return (postDeleteCall.data || {}).success;
        } catch {
            return;
        }
    }
}
